/* ════════════════════════════════════════════════════════════════
   ISODASH MINI-CART  (v10.6.46-dev)
   ────────────────────────────────────────────────────────────────
   Slide-in-Sidebar rechts mit dem aktuellen Shopify-Warenkorb.
   – Fetch via Shopify Ajax Cart API (/cart.js, /cart/change.js)
   – Read-only Mengen (Flaschenzahl folgt dem berechneten Bohrplan)
   – "Zeile entfernen" via POST /cart/change.js { line, quantity:0 }
   – "Sanierung neu berechnen" entfernt nur Sanierungspakete; separate
     Einzelflaschen bleiben im Warenkorb.
   – Dev-Fallback (localhost): synthetisiert einen Demo-Cart aus
     IsoDash.Calculations.getFinalAnalysis(), damit UI lokal testbar
     bleibt. Im Demo-Mode wirken Remove-Aktionen nur auf den Panel-
     State, nicht auf Shopify.

   Public API:
     window.IsoDashMiniCart.open()
     window.IsoDashMiniCart.close()
     window.IsoDashMiniCart.refresh()
   ════════════════════════════════════════════════════════════════ */
(function (w) {
  'use strict';

  var PANEL_ID = 'isodash-mini-cart';
  var CSS_ID   = 'isodash-mini-cart-css';
  var ISOFIN_VARIANT = '55049427616117';

  var _panel    = null;
  var _open     = false;
  var _cartData = null;
  var _busy     = false;

  /* ── Utils ────────────────────────────────────────────────── */
  /* v277: Versandzeit (kompakt repliziert aus iso-shipping-box.js — der Drawer ist global,
     das Original-Script ist nur auf Startseite/Produkt geladen). Cutoff 10:00 Berlin, WE-aware. */
  function mcShipETA() {
    try {
      var TZ = 'Europe/Berlin', CUT = 12;
      function tzNow() {
        var f = new Intl.DateTimeFormat('de-DE', { timeZone: TZ, hour12: false, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' });
        var pp = f.formatToParts(new Date());
        function g(t) { return Number(pp.find(function (x) { return x.type === t; }).value); }
        return new Date(Date.UTC(g('year'), g('month') - 1, g('day'), g('hour') % 24, g('minute'), g('second')));
      }
      /* 02.10.2026 (Paket 0): gleiche Korrektur wie iso-cart-drawer.js/sec-02 – Do–Sa ab 22/23 Uhr stand „Versand So“. Datumswerte sind Berliner Uhrzeit in UTC-Feldern, deshalb nur getUTC/setUTC und Ausgabe mit timeZone 'UTC'; Schluss 12 Uhr Berlin; Wochenende + Feiertage Niedersachsen. */
      function cutUTC(base) { var d = new Date(base); d.setUTCHours(CUT, 0, 0, 0); return d; }
      function isWe(d) { var x = d.getUTCDay(); if (x === 0 || x === 6) return true; var y = d.getUTCFullYear(), md = (d.getUTCMonth() + 1) * 100 + d.getUTCDate(); if (md === 101 || md === 501 || md === 1003 || md === 1031 || md === 1225 || md === 1226) return true; var a = y % 19, b = Math.floor(y / 100), c = y % 100, e = (19 * a + b - Math.floor(b / 4) - Math.floor((b - Math.floor((b + 8) / 25) + 1) / 3) + 15) % 30; var l = (32 + 2 * (b % 4) + 2 * Math.floor(c / 4) - e - (c % 4)) % 7, m = Math.floor((a + 11 * e + 22 * l) / 451), n = e + l - 7 * m + 114; var t = Math.round((Date.UTC(y, d.getUTCMonth(), d.getUTCDate()) - Date.UTC(y, Math.floor(n / 31) - 1, (n % 31) + 1)) / 864e5); return t === -2 || t === 1 || t === 39 || t === 50; }
      var now = tzNow(), ship = new Date(now), todayCut = cutUTC(now);
      if (!isWe(now) && now < todayCut) { ship = todayCut; }
      else { ship.setUTCDate(ship.getUTCDate() + 1); while (isWe(ship)) { ship.setUTCDate(ship.getUTCDate() + 1); } ship = cutUTC(ship); }
      var ms = Math.max(0, ship - now), mins = Math.floor(ms / 60000), h = Math.floor(mins / 60), m = mins % 60;
      var left = h > 0 ? (h + ' Std.' + (m > 0 ? ' ' + m + ' Min.' : '')) : (m + ' Min.');
      var wdL = new Intl.DateTimeFormat('de-DE', { weekday: 'short', timeZone: 'UTC' }).format(ship);
      var day = new Intl.DateTimeFormat('de-DE', { day: 'numeric', timeZone: 'UTC' }).format(ship);
      var mon = new Intl.DateTimeFormat('de-DE', { month: 'long', timeZone: 'UTC' }).format(ship);
      return '🚚 Versand <b>' + wdL + ', ' + day + '. ' + mon + '</b> · Bestellung innerhalb <span class="mc-ship-in">' + left + '</span>';
    } catch (_) { return ''; }
  }

  function formatEuro(cents) {
    var v = Number(cents || 0) / 100;
    return v.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '\u00A0€';
  }

  /* v236.2: HTML-Escape für Cart-Properties (User-Input könnte enthalten sein) */
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function isLocalDev() {
    try {
      var h = location.hostname || '';
      return location.protocol === 'file:' ||
             h === 'localhost' || h === '127.0.0.1' || h.indexOf('.local') !== -1;
    } catch (_) { return false; }
  }

  /* ── Shopify Ajax Cart API ────────────────────────────────── */
  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r && r.ok ? r.json() : null; })
      .catch(function () { return null; })
      .then(function (cart) {
        if (cart && cart.items) return cart;
        /* Dev-Fallback */
        if (isLocalDev()) return buildDemoCart();
        return { items: [], total_price: 0, item_count: 0 };
      });
  }

  function postRemove(lineIdx) {
    if (_cartData && _cartData._demo) {
      /* Dev: lokale Mutation */
      var items = (_cartData.items || []).slice();
      items.splice(lineIdx - 1, 1);
      var total = items.reduce(function (s, it) { return s + (it.final_line_price || it.line_price || 0); }, 0);
      var cnt   = items.reduce(function (s, it) { return s + (it.quantity || 0); }, 0);
      return Promise.resolve({ items: items, total_price: total, item_count: cnt, _demo: true });
    }
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ line: lineIdx, quantity: 0 })
    }).then(function (r) { return r && r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  /* ── Wall-Blurb (personalisierte Zeile über dem Item) ──────
     Liefert z.B. "8 m Horizontalsperre" oder "6,5 m² Flächensperre".
     Liest aus dem Shell-Derivat, das bereits lengthM/isSide/surfaceAreaM2 liefert. */
  function getWallBlurb() {
    try {
      var d = null;
      if (w.IsoDashShell && typeof w.IsoDashShell.tbDerived === 'function') {
        var p = (w.IsoDashShell.moduleStore && typeof w.IsoDashShell.moduleStore.get === 'function')
                ? w.IsoDashShell.moduleStore.get() : {};
        d = w.IsoDashShell.tbDerived(p);
      }
      if (!d || !d.hasAnalysis) return null;
      var isSide = !!d.isSide;
      var label  = isSide ? 'Fl\u00e4chensperre' : 'Horizontalsperre';
      var num, unit;
      if (isSide && d.surfaceAreaM2 && isFinite(d.surfaceAreaM2)) {
        num  = d.surfaceAreaM2;
        unit = 'm\u00B2';
      } else if (d.lengthM && isFinite(d.lengthM)) {
        num  = d.lengthM;
        unit = 'm';
      } else {
        return label;
      }
      var str = (num % 1 === 0)
        ? num.toFixed(0)
        : num.toFixed(1).replace('.', ',');
      return str + '\u00A0' + unit + ' ' + label;
    } catch (_) { return null; }
  }

  function buildDemoCart() {
    try {
      if (w.IsoDash && w.IsoDash.Calculations && typeof w.IsoDash.Calculations.getFinalAnalysis === 'function') {
        var a = w.IsoDash.Calculations.getFinalAnalysis();
        if (a && Number(a.calculatedBottles) > 0) {
          var bottles = Math.max(1, Math.round(a.calculatedBottles));
          var totalC  = Math.round((a.totalPriceIsofin || 0) * 100);
          var unitC   = Math.round(totalC / bottles);
          /* Original-Preis (ohne Staffel) f\u00fcr strike-through */
          var origUnitC = Math.round((w.IsoDash.Calculations.getOriginalPrice
            ? w.IsoDash.Calculations.getOriginalPrice()
            : 19.90) * 100);
          var origTotalC = origUnitC * bottles;
          return {
            items: [{
              key: 'demo-line-1',
              variant_id: ISOFIN_VARIANT,
              product_title: 'Isofin\u00ae Trockene W\u00e4nde',
              title: 'Isofin\u00ae Trockene W\u00e4nde',
              quantity: bottles,
              price: unitC,
              original_line_price: origTotalC,
              line_price: origTotalC,
              final_line_price: totalC,
              image: 'https://cdn.shopify.com/s/files/1/0846/5550/5691/files/sanierungspaket-isofin-500px-1x1.jpg?v=1768280218'
            }],
            total_price: totalC,
            original_total_price: origTotalC,
            item_count: bottles,
            _demo: true
          };
        }
      }
    } catch (_) {}
    return { items: [], total_price: 0, item_count: 0, _demo: true };
  }

  /* \u2500\u2500 Mengenrabatt-Helper \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500
     Berechnet pro Item Original-Preis vs. Staffel-Preis und gibt zur\u00fcck,
     ob ein Rabatt aktiv ist. Funktioniert mit Shopify-Cart-Items UND
     mit unserem internen Calculations-Engine. */
  function getItemDiscount(item) {
    var qty = item.quantity || 0;
    var finalPrc = item.final_line_price != null ? item.final_line_price : (item.line_price || 0);
    var origPrc  = item.original_line_price != null ? item.original_line_price : item.line_price;
    /* Wenn Shopify keinen original_line_price liefert ODER kein Rabatt erkennbar \u2192
       eigene Staffel-Berechnung als Backup (nur f\u00fcr Isofin-Variant). */
    var calc = w.IsoDash && w.IsoDash.Calculations;
    var isIsofin = String(item.variant_id) === ISOFIN_VARIANT;
    if (calc && typeof calc.getDiscountInfo === 'function' && isIsofin && qty > 0) {
      var info = calc.getDiscountInfo(qty);
      var origCents  = Math.round(info.originalTotal * 100);
      var finalCents = Math.round(info.finalTotal * 100);
      /* Wenn Shopify den Brutto-Preis hat (origPrc \u2248 originalTotal), aber wir
         laut Staffel rabattieren \u2192 finalPrc auf Staffel-Wert korrigieren. */
      if (info.hasDiscount && Math.abs(finalPrc - origCents) < 50) {
        finalPrc = finalCents;
      }
      /* Original-Preis ggf. erg\u00e4nzen, falls Shopify ihn nicht liefert. */
      if (origPrc == null || origPrc < finalPrc) {
        origPrc = origCents;
      }
    }
    if (origPrc == null) origPrc = finalPrc;
    var hasDiscount = origPrc > finalPrc;
    return {
      qty: qty,
      finalPrc: finalPrc,
      origPrc: origPrc,
      saved: hasDiscount ? (origPrc - finalPrc) : 0,
      hasDiscount: hasDiscount
    };
  }

  function getCartTotals(cart) {
    if (!cart || !cart.items || !cart.items.length) {
      return { final: 0, original: 0, saved: 0, hasDiscount: false };
    }
    var fSum = 0, oSum = 0;
    cart.items.forEach(function (it) {
      var d = getItemDiscount(it);
      fSum += d.finalPrc;
      oSum += d.origPrc;
    });
    /* Bevorzugt Shopify's gemeldete Werte, wenn verf\u00fcgbar */
    if (cart.total_price != null) fSum = cart.total_price;
    if (cart.original_total_price != null && cart.original_total_price > fSum) {
      oSum = cart.original_total_price;
    }
    return {
      final: fSum,
      original: Math.max(oSum, fSum),
      saved: Math.max(0, oSum - fSum),
      hasDiscount: oSum > fSum
    };
  }

  /* ── CSS ─────────────────────────────────────────────────── */
  function injectCSS() {
    if (document.getElementById(CSS_ID)) return;
    var p = '#' + PANEL_ID;
    var st = document.createElement('style');
    st.id = CSS_ID;
    /* Alle Layout-Props mit !important gegen GemPages/Shopify-Theme-Resets.
       Das Mini-Cart muss themeunabhängig konsistent rendern. */
    var I = ' !important';
    st.textContent = [
      /* ─── Shell ─────────────────────────────────────────── */
      p + '{position:fixed'+I+';inset:0'+I+';z-index:99999'+I+';pointer-events:none'+I+';font-family:inherit'+I+';font-variant-numeric:tabular-nums'+I+'}',
      p + ' *{box-sizing:border-box'+I+'}',
      p + ' .mc-backdrop{position:absolute'+I+';inset:0'+I+';background:radial-gradient(ellipse at top right,rgba(10,10,12,.55) 0%,rgba(10,10,12,.35) 80%)'+I+';opacity:0'+I+';transition:opacity .3s ease'+I+';pointer-events:none'+I+';backdrop-filter:blur(2px);-webkit-backdrop-filter:blur(2px)}',
      p + ' .mc-panel{position:absolute'+I+';top:0'+I+';right:0'+I+';bottom:0'+I+';width:440px'+I+';max-width:92vw'+I+';background:var(--ds-surface,#fff)'+I+';color:var(--ds-text,#111)'+I+';box-shadow:-16px 0 48px rgba(0,0,0,.18),-2px 0 8px rgba(0,0,0,.08)'+I+';transform:translateX(105%)'+I+';transition:transform .35s cubic-bezier(.4,0,.2,1)'+I+';display:flex'+I+';flex-direction:column'+I+';pointer-events:auto'+I+';border-left:1px solid var(--ds-border,rgba(0,0,0,.08))'+I+';margin:0'+I+'}',
      p + '.mc-open .mc-backdrop{opacity:1'+I+';pointer-events:auto'+I+'}',
      p + '.mc-open .mc-panel{transform:translateX(0)'+I+'}',

      /* ─── Header ────────────────────────────────────────── */
      /* v291: Header in Brand-Rot abgesetzt; bewusst feste Farben (kein --ds-*), damit Dark-Mode ihn nicht kippt */
      p + ' .mc-head{display:flex'+I+';align-items:center'+I+';justify-content:space-between'+I+';gap:16px'+I+';padding:22px 24px 18px'+I+';border:none'+I+';border-bottom:1px solid rgba(0,0,0,.10)'+I+';flex-shrink:0'+I+';background:linear-gradient(180deg,#D6001C 0%,#B8001A 100%)'+I+';margin:0'+I+'}',
      p + ' .mc-head-title{display:flex'+I+';flex-direction:column'+I+';gap:3px'+I+';min-width:0'+I+';padding:0'+I+';margin:0'+I+'}',
      p + ' .mc-head-title h3{margin:0'+I+';padding:0'+I+';font-size:19px'+I+';font-weight:700'+I+';color:#fff'+I+';line-height:1.2'+I+';letter-spacing:-.01em'+I+';border:none'+I+'}',
      p + ' .mc-head-sub{font-size:12px'+I+';color:rgba(255,255,255,.85)'+I+';font-weight:500'+I+';line-height:1'+I+';padding:0'+I+';margin:0'+I+'}',
      p + ' .mc-close{display:inline-flex'+I+';align-items:center'+I+';justify-content:center'+I+';width:36px'+I+';height:36px'+I+';background:transparent'+I+';border:none'+I+';border-radius:10px'+I+';color:rgba(255,255,255,.92)'+I+';cursor:pointer'+I+';transition:background .18s,color .18s'+I+';flex-shrink:0'+I+';padding:0'+I+';margin:0'+I+';font-family:inherit'+I+'}',
      p + ' .mc-close svg{width:18px'+I+';height:18px'+I+';display:block'+I+'}',
      p + ' .mc-close:hover{background:rgba(255,255,255,.16)'+I+';color:#fff'+I+'}',

      /* ─── Body ──────────────────────────────────────────── */
      p + ' .mc-body{flex:1'+I+';overflow-y:auto'+I+';overflow-x:hidden'+I+';padding:20px 20px 12px'+I+';display:flex'+I+';flex-direction:column'+I+';gap:12px'+I+';-webkit-overflow-scrolling:touch;background:transparent'+I+';margin:0'+I+'}',
      p + ' .mc-body::-webkit-scrollbar{width:6px}',
      p + ' .mc-body::-webkit-scrollbar-thumb{background:var(--ds-border,rgba(0,0,0,.12));border-radius:3px}',

      /* ─── Item-Card (enth\u00e4lt Ware + USPs in einer Umrandung) ── */
      p + ' .mc-item{position:relative'+I+';display:flex'+I+';flex-direction:column'+I+';gap:0'+I+';padding:16px'+I+';background:var(--ds-surface-el,#fafafa)'+I+';border:1px solid var(--ds-border,rgba(0,0,0,.08))'+I+';border-radius:14px'+I+';transition:border-color .18s,transform .2s,box-shadow .2s'+I+';margin:0'+I+'}',
      p + ' .mc-item-main{display:grid'+I+';grid-template-columns:84px 1fr'+I+';gap:16px'+I+';padding:0'+I+';margin:0'+I+'}',
      p + ' .mc-item:hover{border-color:var(--ds-border-hover,rgba(0,0,0,.14))'+I+'}',
      p + ' .mc-item.mc-item-leaving{opacity:0'+I+';transform:translateX(20px)'+I+';transition:opacity .25s,transform .25s'+I+'}',
      /* X-Button: entfernt nur die jeweilige Warenkorb-Zeile. */
      p + ' .mc-item-x{position:absolute'+I+';top:8px'+I+';right:8px'+I+';width:28px'+I+';height:28px'+I+';min-width:28px'+I+';max-width:28px'+I+';min-height:28px'+I+';max-height:28px'+I+';box-sizing:border-box'+I+';aspect-ratio:1'+I+';background:rgba(0,0,0,.04)'+I+';border:1px solid rgba(0,0,0,.08)'+I+';border-radius:50%'+I+';color:var(--ds-text-muted,#666)'+I+';cursor:pointer'+I+';display:inline-flex'+I+';align-items:center'+I+';justify-content:center'+I+';padding:0'+I+';margin:0'+I+';transition:background .15s,color .15s,border-color .15s'+I+';font-family:inherit'+I+';z-index:2'+I+'}',
      p + ' .mc-item-x svg{width:14px'+I+';height:14px'+I+';display:block'+I+'}',
      p + ' .mc-item-x:hover{background:rgba(208,16,48,.08)'+I+';color:#D6001C'+I+';border-color:rgba(208,16,48,.25)'+I+'}',
      p + ' .mc-item-x:active{transform:scale(.92)'+I+'}',
      p + ' .mc-item-recalc{display:inline-flex'+I+';align-items:center'+I+';justify-content:center'+I+';gap:8px'+I+';width:100%'+I+';margin:12px 0 0'+I+';padding:10px 12px'+I+';background:#fff'+I+';color:var(--ds-text,#111)'+I+';border:1px solid var(--ds-border,rgba(0,0,0,.12))'+I+';border-radius:10px'+I+';font-size:12px'+I+';font-weight:700'+I+';line-height:1.2'+I+';cursor:pointer'+I+';font-family:inherit'+I+';box-shadow:none'+I+';transition:border-color .18s,color .18s,background .18s'+I+'}',
      p + ' .mc-item-recalc svg{width:14px'+I+';height:14px'+I+';display:block'+I+'}',
      p + ' .mc-item-recalc:hover{border-color:var(--ds-accent,#D6001C)'+I+';color:var(--ds-accent,#D6001C)'+I+';background:var(--ds-accent-soft,rgba(214,0,28,.04))'+I+'}',
      /* Trust-Bar im Footer (zwischen Zwischensumme & Checkout) — Bewertung + Customer-Count */
      p + ' .mc-trust{display:flex'+I+';flex-direction:column'+I+';align-items:center'+I+';gap:3px'+I+';padding:10px 12px'+I+';margin:10px 0 0'+I+';background:linear-gradient(180deg,rgba(255,184,28,.08) 0%,rgba(255,184,28,.02) 100%)'+I+';border:1px solid rgba(255,184,28,.22)'+I+';border-radius:10px'+I+';line-height:1.2'+I+'}',
      p + ' .mc-trust-rating{display:inline-flex'+I+';align-items:center'+I+';gap:8px'+I+';flex-wrap:wrap'+I+';justify-content:center'+I+'}',
      p + ' .mc-trust-stars{display:inline-block'+I+';color:#FFAB00'+I+';font-size:15px'+I+';letter-spacing:1px'+I+';line-height:1'+I+'}',
      p + ' .mc-trust-text{font-size:13px'+I+';color:var(--ds-text,#111)'+I+';font-weight:500'+I+';line-height:1.2'+I+'}',
      p + ' .mc-trust-text strong{font-weight:700'+I+';color:var(--ds-text,#111)'+I+'}',
      p + ' .mc-trust-sub{font-size:11px'+I+';color:var(--ds-text-muted,#666)'+I+';font-weight:500'+I+';letter-spacing:.01em'+I+'}',
      p + ' .mc-thumb{width:84px'+I+';height:84px'+I+';object-fit:cover'+I+';border-radius:10px'+I+';background:var(--ds-surface,#fff)'+I+';border:1px solid var(--ds-border,rgba(0,0,0,.06))'+I+';flex-shrink:0'+I+';display:block'+I+';padding:0'+I+';margin:0'+I+'}',
      p + ' .mc-info{display:flex'+I+';flex-direction:column'+I+';gap:8px'+I+';min-width:0'+I+';padding:0'+I+';margin:0'+I+'}',
      p + ' .mc-name{font-size:15px'+I+';font-weight:700'+I+';color:var(--ds-text,#111)'+I+';line-height:1.3'+I+';letter-spacing:-.005em'+I+';margin:0'+I+';padding:0 36px 0 0'+I+';overflow:hidden'+I+';text-overflow:ellipsis;display:-webkit-box'+I+';-webkit-line-clamp:2;-webkit-box-orient:vertical;border:none'+I+'}',
      p + ' .mc-qty-text{font-size:13px'+I+';color:var(--ds-text-muted,#666)'+I+';font-weight:500'+I+';padding:0'+I+';margin:0'+I+';line-height:1.3'+I+'}',
      p + ' .mc-stepper{display:inline-flex'+I+';align-items:center'+I+';border:1px solid var(--ds-border,rgba(0,0,0,.16))'+I+';border-radius:9px'+I+';overflow:hidden'+I+';background:#fff'+I+'}',
      p + ' .mc-step{width:30px'+I+';height:30px'+I+';border:0'+I+';background:#fff'+I+';color:var(--ds-text,#111)'+I+';font-size:17px'+I+';line-height:1'+I+';font-weight:600'+I+';cursor:pointer'+I+';padding:0'+I+';display:flex'+I+';align-items:center'+I+';justify-content:center'+I+'}',
      p + ' .mc-step:hover{background:#F5F5F5'+I+'}',
      p + ' .mc-step-val{min-width:30px'+I+';text-align:center'+I+';font-size:14px'+I+';font-weight:700'+I+';color:var(--ds-text,#111)'+I+'}',
      p + ' .mc-calc-hint{font-size:12px'+I+';color:var(--ds-text-muted,#666)'+I+';line-height:1.4'+I+';margin-top:6px'+I+'}',
      p + ' .mc-calc-hint a{color:#D6001C'+I+';text-decoration:underline'+I+';font-weight:600'+I+'}',
      /* v236.2: Cart-Properties (z.B. "Berechnung: 8 Meter Horizontalsperre · 2 Ecken · 36 cm Wandstärke") */
      p + ' .mc-props{display:flex'+I+';flex-direction:column'+I+';gap:2px'+I+';padding:0'+I+';margin:0'+I+'}',
      p + ' .mc-prop-row{font-size:12px'+I+';line-height:1.35'+I+';color:var(--ds-text-muted,#666)'+I+';padding:0'+I+';margin:0'+I+'}',
      p + ' .mc-prop-key{font-weight:600'+I+';color:var(--ds-text,#111)'+I+'}',
      p + ' .mc-prop-val{font-weight:500'+I+'}',
      /* v236.3: Tax/Shipping Note + Free-Shipping Highlight */
      p + ' .mc-tax-note{display:block'+I+';font-size:11px'+I+';color:var(--ds-text-muted,#666)'+I+';line-height:1.3'+I+';margin:2px 0 0'+I+'}',
      p + ' .mc-tax-note--free{color:var(--ds-green,#0A7D56)'+I+';font-weight:600'+I+'}',
      p + ' .mc-tax-note--free strong{font-weight:800'+I+'}',
      p + ' .mc-price{display:block'+I+';text-align:right'+I+';font-size:18px'+I+';font-weight:800'+I+';color:var(--ds-text,#111)'+I+';letter-spacing:-.01em'+I+';line-height:1'+I+';padding:0'+I+';margin:6px 0 0'+I+'}',

      /* ─── Mengenrabatt: Strike-Through + Saved + Tier-Badge ── */
      p + ' .mc-price-wrap{display:flex'+I+';flex-direction:column'+I+';align-items:flex-end'+I+';gap:2px'+I+';margin:6px 0 0'+I+';padding:0'+I+'}',
      p + ' .mc-price-orig{display:block'+I+';text-align:right'+I+';font-size:13px'+I+';font-weight:500'+I+';color:var(--ds-text-dim,#999)'+I+';text-decoration:line-through'+I+';line-height:1'+I+';padding:0'+I+';margin:0'+I+'}',
      p + ' .mc-price-wrap .mc-price{margin:0'+I+';color:var(--ds-green,#0A7D56)'+I+'}',
      p + ' .mc-price-saved{display:inline-flex'+I+';align-items:center'+I+';font-size:11px'+I+';font-weight:600'+I+';color:var(--ds-green,#0A7D56)'+I+';background:rgba(45,212,160,.10)'+I+';border-radius:6px'+I+';padding:3px 7px'+I+';margin:4px 0 0'+I+';line-height:1.2'+I+';letter-spacing:.01em'+I+'}',
      p + ' .mc-tier-badge{display:flex'+I+';align-items:center'+I+';gap:8px'+I+';padding:8px 12px'+I+';margin:0 0 12px'+I+';background:linear-gradient(180deg,rgba(45,212,160,.10) 0%,rgba(45,212,160,.04) 100%)'+I+';border:1px solid rgba(45,212,160,.28)'+I+';border-radius:10px'+I+';font-size:12px'+I+';color:var(--ds-text,#111)'+I+';line-height:1.35'+I+'}',
      p + ' .mc-tier-ico{display:inline-flex'+I+';align-items:center'+I+';justify-content:center'+I+';width:22px'+I+';height:22px'+I+';color:var(--ds-green,#0A7D56)'+I+';flex-shrink:0'+I+'}',
      p + ' .mc-tier-ico svg{width:14px'+I+';height:14px'+I+'}',
      p + ' .mc-tier-txt{flex:1'+I+';min-width:0'+I+';font-weight:500'+I+'}',
      p + ' .mc-tier-txt strong{font-weight:700'+I+';color:var(--ds-green,#0A7D56)'+I+'}',
      /* Footer-Aufschlüsselung (Listenpreis / Mengenrabatt) */
      p + ' .mc-total-detail{display:flex'+I+';flex-direction:column'+I+';gap:4px'+I+';padding:10px 12px'+I+';margin:0'+I+';background:var(--ds-surface-el,#fafafa)'+I+';border:1px solid var(--ds-border,rgba(0,0,0,.06))'+I+';border-radius:10px'+I+'}',
      p + ' .mc-total-row{display:flex'+I+';justify-content:space-between'+I+';align-items:baseline'+I+';gap:12px'+I+';font-size:13px'+I+';line-height:1.3'+I+';padding:0'+I+';margin:0'+I+'}',
      p + ' .mc-total-row span{padding:0'+I+';margin:0'+I+'}',
      p + ' .mc-total-row-orig{color:var(--ds-text-muted,#666)'+I+'}',
      p + ' .mc-total-orig-val{text-decoration:line-through'+I+';font-weight:500'+I+'}',
      p + ' .mc-total-row-saved{color:var(--ds-green,#0A7D56)'+I+';font-weight:600'+I+'}',
      p + ' .mc-total-saved-val{font-weight:700'+I+'}',

      /* ─── Sekundärer Reset-Button (im Footer) ────────────── */
      p + ' .mc-reset{display:inline-flex'+I+';align-items:center'+I+';justify-content:center'+I+';gap:8px'+I+';width:100%'+I+';padding:11px 18px'+I+';background:transparent'+I+';color:var(--ds-text-muted,#666)'+I+';border:1px solid var(--ds-border,rgba(0,0,0,.12))'+I+';border-radius:10px'+I+';font-size:13px'+I+';font-weight:600'+I+';letter-spacing:.01em'+I+';cursor:pointer'+I+';font-family:inherit'+I+';transition:border-color .18s,color .18s,background .18s'+I+';box-shadow:none'+I+';margin:0'+I+'}',
      p + ' .mc-reset svg{width:15px'+I+';height:15px'+I+'}',
      p + ' .mc-reset:hover{border-color:var(--ds-text-muted,#666)'+I+';color:var(--ds-text,#111)'+I+';background:var(--ds-surface-hover,rgba(0,0,0,.03))'+I+'}',
      p + ' .mc-reset:active{background:var(--ds-surface-el,#f6f6f6)'+I+'}',

      /* ─── Empty-State ───────────────────────────────────── */
      p + ' .mc-empty{display:flex'+I+';flex-direction:column'+I+';align-items:center'+I+';justify-content:center'+I+';text-align:center'+I+';gap:14px'+I+';padding:60px 24px 40px'+I+';color:var(--ds-text-muted,#666)'+I+';min-height:320px'+I+';margin:0'+I+'}',
      p + ' .mc-empty-icon{width:72px'+I+';height:72px'+I+';border-radius:50%'+I+';background:var(--ds-surface-el,#f6f6f6)'+I+';display:inline-flex'+I+';align-items:center'+I+';justify-content:center'+I+';color:var(--ds-text-dim,#aaa)'+I+';border:1px dashed var(--ds-border-strong,rgba(0,0,0,.12))'+I+';padding:0'+I+';margin:0'+I+'}',
      p + ' .mc-empty-icon svg{width:32px'+I+';height:32px'+I+'}',
      p + ' .mc-empty-title{font-size:17px'+I+';font-weight:700'+I+';color:var(--ds-text,#111)'+I+';margin:4px 0 0'+I+';letter-spacing:-.005em'+I+';padding:0'+I+';border:none'+I+'}',
      p + ' .mc-empty-text{font-size:13px'+I+';line-height:1.55'+I+';color:var(--ds-text-muted,#666)'+I+';max-width:260px'+I+';margin:0'+I+';padding:0'+I+'}',
      p + ' .mc-empty-cta{display:inline-flex'+I+';align-items:center'+I+';justify-content:center'+I+';gap:6px'+I+';padding:11px 20px'+I+';background:transparent'+I+';border:1.5px solid var(--ds-border-strong,rgba(0,0,0,.16))'+I+';border-radius:10px'+I+';color:var(--ds-text,#111)'+I+';font-size:13px'+I+';font-weight:600'+I+';cursor:pointer'+I+';font-family:inherit'+I+';text-decoration:none'+I+';margin:8px 0 0'+I+';transition:border-color .2s,background .2s'+I+'}',
      p + ' .mc-empty-cta:hover{border-color:var(--ds-accent,#D6001C)'+I+';color:var(--ds-accent,#D6001C)'+I+';background:var(--ds-accent-soft,rgba(214,0,28,.04))'+I+'}',

      /* ─── Footer ────────────────────────────────────────── */
      p + ' .mc-foot{border:none'+I+';border-top:1px solid var(--ds-border,rgba(0,0,0,.08))'+I+';padding:20px 24px calc(20px + env(safe-area-inset-bottom,0px))'+I+';background:var(--ds-surface,#fff)'+I+';flex-shrink:0'+I+';display:flex'+I+';flex-direction:column'+I+';gap:14px'+I+';margin:0'+I+'}',
      p + ' .mc-total{display:flex'+I+';justify-content:space-between'+I+';align-items:baseline'+I+';gap:16px'+I+';padding:0'+I+';margin:0'+I+'}',
      p + ' .mc-total-lbl{display:flex'+I+';flex-direction:column'+I+';gap:2px'+I+';padding:0'+I+';margin:0'+I+'}',
      p + ' .mc-total-lbl span{font-size:14px'+I+';font-weight:600'+I+';color:var(--ds-text,#111)'+I+';line-height:1.2'+I+';padding:0'+I+';margin:0'+I+'}',
      p + ' .mc-total-lbl small{font-size:11px'+I+';color:var(--ds-text-dim,#888)'+I+';font-weight:500'+I+';padding:0'+I+';margin:0'+I+'}',
      p + ' .mc-total-val{font-size:24px'+I+';font-weight:800'+I+';color:var(--ds-text,#111)'+I+';line-height:1'+I+';letter-spacing:-.02em'+I+';padding:0'+I+';margin:0'+I+'}',
      p + ' .mc-checkout{display:flex'+I+';align-items:center'+I+';justify-content:center'+I+';gap:10px'+I+';width:100%'+I+';padding:15px 24px'+I+';background:linear-gradient(180deg,#D6001C 0%,#A80016 100%)'+I+';color:#fff'+I+';border:none'+I+';border-radius:12px'+I+';font-size:16px'+I+';font-weight:700'+I+';letter-spacing:.01em'+I+';cursor:pointer'+I+';font-family:inherit'+I+';box-shadow:0 6px 16px rgba(214,0,28,.30),0 2px 4px rgba(214,0,28,.20),inset 0 -2px 0 rgba(0,0,0,.12)'+I+';transition:transform .15s,box-shadow .2s'+I+';position:relative'+I+';margin:0'+I+'}',
      p + ' .mc-checkout:hover{transform:translateY(-1px)'+I+';box-shadow:0 8px 24px rgba(214,0,28,.40),0 2px 6px rgba(214,0,28,.24),inset 0 -2px 0 rgba(0,0,0,.12)'+I+'}',
      p + ' .mc-checkout:active{transform:translateY(0)'+I+';box-shadow:0 4px 12px rgba(214,0,28,.28),inset 0 -1px 0 rgba(0,0,0,.12)'+I+'}',
      p + ' .mc-checkout svg{width:16px'+I+';height:16px'+I+'}',
      p + ' .mc-dynamic-slot{display:block'+I+';width:100%'+I+';min-height:0'+I+';margin:-4px 0 0'+I+';padding:0'+I+'}',
      p + ' .mc-dynamic-slot[hidden]{display:none'+I+'}',
      p + ' .mc-dynamic-checkout,.mc-dynamic-checkout .additional-checkout-buttons{display:block'+I+';width:100%'+I+';margin:0'+I+';padding:0'+I+'}',
      p + ' .mc-dynamic-checkout [data-shopify-buttoncontainer],'+p+' .mc-dynamic-checkout .shopify-cleanslate{width:100%'+I+'}',
      /* v291: max-height deckelt den Lade-Skeleton (gestapelte Wallet-Platzhalter) auf 1 Button-Zeile */
      p + ' .mc-dynamic-checkout shopify-accelerated-checkout-cart{display:block'+I+';width:100%'+I+';max-height:56px'+I+';overflow:hidden'+I+'}',
      p + ' .mc-dynamic-checkout #dynamic-checkout-cart{display:block'+I+';width:100%'+I+'}',
      /* ─── Personalisierter Hero-Banner (gr\u00fcn = positives Signal) ── */
      p + ' .mc-hero-banner{display:flex'+I+';align-items:center'+I+';gap:12px'+I+';padding:14px 16px'+I+';background:rgba(45,212,160,.08)'+I+';border:1px solid rgba(45,212,160,.28)'+I+';border-radius:12px'+I+';margin:0'+I+'}',
      p + ' .mc-hero-icon{display:inline-flex'+I+';align-items:center'+I+';justify-content:center'+I+';width:34px'+I+';height:34px'+I+';border-radius:10px'+I+';background:var(--ds-green,#2DD4A0)'+I+';color:#fff'+I+';flex-shrink:0'+I+'}',
      p + ' .mc-hero-icon svg{width:16px'+I+';height:16px'+I+';display:block'+I+'}',
      p + ' .mc-hero-text{display:flex'+I+';flex-direction:column'+I+';gap:2px'+I+';min-width:0'+I+';padding:0'+I+';margin:0'+I+'}',
      p + ' .mc-hero-eyebrow{font-size:11px'+I+';font-weight:700'+I+';letter-spacing:.06em'+I+';text-transform:uppercase'+I+';color:var(--ds-green,#2DD4A0)'+I+';line-height:1.2'+I+';margin:0'+I+'}',
      p + ' .mc-hero-detail{font-size:15px'+I+';font-weight:700'+I+';color:var(--ds-text,#111)'+I+';line-height:1.25'+I+';letter-spacing:-.005em'+I+';margin:0'+I+'}',

      /* ─── Produkt-USPs (eingebettet in die Item-Card, durch Separator getrennt) ─ */
      p + ' .mc-usp{list-style:none'+I+';padding:14px 0 0'+I+';margin:14px 0 0'+I+';background:transparent'+I+';border:none'+I+';border-top:1px solid var(--ds-border,rgba(0,0,0,.08))'+I+';border-radius:0'+I+';display:flex'+I+';flex-direction:column'+I+';gap:10px'+I+'}',
      p + ' .mc-usp-row{display:flex'+I+';align-items:flex-start'+I+';gap:10px'+I+';font-size:13px'+I+';color:var(--ds-text,#111)'+I+';font-weight:500'+I+';line-height:1.4'+I+';padding:0'+I+';margin:0'+I+'}',
      p + ' .mc-usp-ico{display:inline-flex'+I+';align-items:center'+I+';justify-content:center'+I+';width:18px'+I+';height:18px'+I+';border-radius:50%'+I+';background:var(--ds-green,#2DD4A0)'+I+';color:#fff'+I+';flex-shrink:0'+I+';margin-top:1px'+I+'}',
      p + ' .mc-usp-ico svg{width:11px'+I+';height:11px'+I+';display:block'+I+';stroke-width:3'+I+'}',
      p + ' .mc-usp-txt{flex:1'+I+';min-width:0'+I+'}',

      /* ─── Dev-Hint ──────────────────────────────────────── */
      p + ' .mc-dev-hint{display:block'+I+';padding:8px 12px'+I+';border:1px dashed var(--ds-border-strong,rgba(0,0,0,.14))'+I+';border-radius:8px'+I+';font-size:11px'+I+';color:var(--ds-text-dim,#888)'+I+';text-align:center'+I+';background:var(--ds-surface-el,#fafafa)'+I+';line-height:1.4'+I+';letter-spacing:.01em'+I+';margin:0'+I+'}',

      /* ─── Mobile ────────────────────────────────────────── */
      /* ─── v277: schlanker Drawer (Sterne, USP-Box, Versandzeile, Pfeil-im-Kreis, Minus-Ecke) ── */
      p + ' .mc-info{gap:4px'+I+'}',
      p + ' .mc-foot{box-shadow:0 -12px 28px -10px rgba(0,0,0,.16)'+I+';border-top:2px solid var(--ds-border-strong,rgba(0,0,0,.16))'+I+';background:var(--ds-surface-el,#fafafa)'+I+'}',
      /* v277: Dynamic-/Express-Checkout immer unter dem CTA + zentriert */
      p + ' .mc-dynamic-slot{display:flex'+I+';flex-direction:column'+I+';align-items:center'+I+';justify-content:center'+I+'}',
      p + ' .mc-dynamic-checkout{text-align:center'+I+'}',
      p + ' .mc-dynamic-checkout [data-shopify-buttoncontainer]{justify-content:center'+I+';margin-left:auto'+I+';margin-right:auto'+I+'}',
      p + ' .mc-name{font-size:14px'+I+';-webkit-line-clamp:1'+I+';padding:0 6px 0 0'+I+'}',
      p + ' .mc-item-rating{display:flex'+I+';align-items:center'+I+';gap:6px'+I+';font-size:11px'+I+';color:var(--ds-text-muted,#666)'+I+';line-height:1'+I+';margin:0'+I+'}',
      p + ' .mc-item-stars{color:#FFAB00'+I+';font-size:11px'+I+';letter-spacing:.5px'+I+'}',
      p + ' .mc-item-rtxt strong{font-weight:700'+I+';color:var(--ds-text,#111)'+I+'}',
      p + ' .mc-qtyprice{display:flex'+I+';align-items:baseline'+I+';justify-content:space-between'+I+';gap:10px'+I+';margin:3px 0 0'+I+'}',
      p + ' .mc-qtyprice .mc-qty-text{margin:0'+I+'}',
      p + ' .mc-qtyprice .mc-price{margin:0'+I+';font-size:15px'+I+';font-weight:700'+I+';color:#555'+I+'}',
      p + ' .mc-item-x{top:-9px'+I+';right:-9px'+I+';width:26px'+I+';height:26px'+I+';background:#fff'+I+';box-shadow:0 1px 4px rgba(0,0,0,.10)'+I+'}',
      p + ' .mc-item-x svg{width:14px'+I+';height:14px'+I+'}',
      p + ' .mc-usp-box{margin:0'+I+';padding:14px'+I+';background:var(--ds-surface-el,#fafafa)'+I+';border:1px solid var(--ds-border,rgba(0,0,0,.08))'+I+';border-radius:14px'+I+'}',
      p + ' .mc-usp-box .mc-usp{border-top:none'+I+';padding:0'+I+';margin:0'+I+';gap:9px'+I+'}',
      p + ' .mc-usp-ttl{font-size:10.5px'+I+';font-weight:700'+I+';color:var(--ds-text-muted,#666)'+I+';text-transform:uppercase'+I+';letter-spacing:.07em'+I+';margin:0 0 10px'+I+'}',
      p + ' .mc-ship{width:100%'+I+';text-align:center'+I+';font-size:11px'+I+';color:var(--ds-text-muted,#666)'+I+';font-weight:500'+I+';line-height:1.3'+I+';white-space:nowrap'+I+';overflow:hidden'+I+';text-overflow:ellipsis'+I+';padding:2px 0'+I+';margin:0'+I+'}',
      p + ' .mc-ship b{color:var(--ds-text,#111)'+I+';font-weight:700'+I+'}',
      p + ' .mc-ship-in{color:var(--ds-green,#0A7D56)'+I+';font-weight:700'+I+'}',
      p + ' .mc-checkout .isf-arrow-circle{display:inline-flex'+I+';align-items:center'+I+';justify-content:center'+I+';width:26px'+I+';height:26px'+I+';min-width:26px'+I+';background:rgba(255,255,255,0.2)'+I+';border-radius:50%'+I+';animation:isf-arrow-move-full 1.2s ease-in-out infinite'+I+'}',
      p + ' .mc-checkout .isf-arrow-circle svg{width:14px'+I+';height:14px'+I+';display:block'+I+'}',
      p + ' .mc-checkout:hover .isf-arrow-circle{transform:translateX(4px)'+I+';animation:none'+I+'}',
      '@keyframes isf-arrow-move-full{0%,100%{transform:translateX(0)}50%{transform:translateX(3px)}}',
      /* v277: CTA-Optik exakt wie Startseite (.isf-hero-cta) — Shine-Sweep + Puls + heller Hover-Verlauf */
      p + ' .mc-checkout{overflow:hidden'+I+';animation:isf-cta-pulse-full 2.4s ease-in-out infinite'+I+'}',
      p + ' .mc-checkout::after{content:""'+I+';position:absolute'+I+';inset:-40% -60%'+I+';background:linear-gradient(120deg,transparent 0%,rgba(255,255,255,0.18) 45%,rgba(255,255,255,0.35) 50%,rgba(255,255,255,0.18) 55%,transparent 100%)'+I+';transform:translateX(-120%) rotate(8deg)'+I+';animation:isf-cta-shine-full 3.8s ease-in-out infinite'+I+';pointer-events:none'+I+'}',
      p + ' .mc-checkout:hover{background:linear-gradient(180deg,#FF0020 0%,#C4001A 100%)'+I+';animation:none'+I+'}',
      '@keyframes isf-cta-pulse-full{0%,100%{transform:translateY(0) scale(1)}50%{transform:translateY(-1px) scale(1.008)}}',
      '@keyframes isf-cta-shine-full{0%,70%{transform:translateX(-120%) rotate(8deg);opacity:0}80%{opacity:1}100%{transform:translateX(120%) rotate(8deg);opacity:0}}',

      '@media (max-width:520px){',
      '  ' + p + ' .mc-panel{width:100%'+I+';max-width:100%'+I+';border-left:none'+I+'}',
      '  ' + p + ' .mc-head{padding:18px 20px 14px'+I+'}',
      '  ' + p + ' .mc-body{padding:16px 16px 8px'+I+'}',
      '  ' + p + ' .mc-item{padding:14px'+I+';grid-template-columns:72px 1fr'+I+';gap:12px'+I+'}',
      '  ' + p + ' .mc-thumb{width:72px'+I+';height:72px'+I+'}',
      '  ' + p + ' .mc-foot{padding:18px 20px calc(18px + env(safe-area-inset-bottom,0px))'+I+'}',
      '  ' + p + ' .mc-total-val{font-size:22px'+I+'}',
      '}'
    ].join('\n');
    (document.head || document.documentElement).appendChild(st);
  }

  /* ── Inline-Icons (stroke = currentColor) ─────────────────── */
  var ICO = {
    close:    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>',
    cart:     '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>',
    arrow:    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>',
    refresh:  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="23 4 23 10 17 10"/><polyline points="1 20 1 14 7 14"/><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10"/><path d="M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/></svg>',
    check:    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>',
    verified: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"/><path d="m9 12 2 2 4-4"/></svg>',
    tag:      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>'
  };

  /* ── DOM ──────────────────────────────────────────────────── */
  function buildPanel() {
    var el = document.createElement('div');
    el.id = PANEL_ID;
    el.innerHTML =
      '<div class="mc-backdrop" data-mc-close></div>' +
      '<aside class="mc-panel" role="dialog" aria-modal="true" aria-label="Warenkorb">' +
        '<header class="mc-head">' +
          '<div class="mc-head-title">' +
            '<h3>Ihr Warenkorb</h3>' +
            '<div class="mc-head-sub" id="mc-head-sub">&nbsp;</div>' +
          '</div>' +
          '<button class="mc-close" data-mc-close aria-label="Warenkorb schlie\u00dfen" title="Schlie\u00dfen">' + ICO.close + '</button>' +
        '</header>' +
        '<div class="mc-body" id="mc-body"></div>' +
        '<footer class="mc-foot" id="mc-foot"></footer>' +
      '</aside>';

    el.addEventListener('click', function (e) {
      if (e.target.closest('[data-mc-close]')) { close(); return; }
      var removeBtn = e.target.closest('[data-mc-remove]');
      if (removeBtn) {
        e.preventDefault();
        removeLine(removeBtn.getAttribute('data-mc-remove'));
        return;
      }
      var incBtn = e.target.closest('[data-mc-inc]');
      if (incBtn) { e.preventDefault(); var _li = parseInt(incBtn.getAttribute('data-mc-inc'), 10); var _it = _cartData && _cartData.items && _cartData.items[_li - 1]; changeQty(_li, (_it ? _it.quantity : 1) + 1); return; }
      var decBtn = e.target.closest('[data-mc-dec]');
      if (decBtn) { e.preventDefault(); var _ld = parseInt(decBtn.getAttribute('data-mc-dec'), 10); var _id = _cartData && _cartData.items && _cartData.items[_ld - 1]; changeQty(_ld, (_id ? _id.quantity : 1) - 1); return; }
      if (e.target.closest('[data-mc-recalc]') || e.target.closest('[data-mc-reset]')) {
        e.preventDefault();
        handleReset();
      }
    });

    /* ESC to close */
    document.addEventListener('keydown', function (e) {
      if (_open && e.key === 'Escape') close();
    });

    /* Panel innerhalb #isodash anhängen → erbt CSS-Variablen + Theme. */
    var host = document.getElementById('isodash') || document.body;
    host.appendChild(el);
    return el;
  }

  function getRootUrl() {
    var root = '/';
    try {
      if (w.Shopify && w.Shopify.routes && w.Shopify.routes.root) root = w.Shopify.routes.root;
    } catch (_) {}
    if (!root) root = '/';
    if (root.charAt(root.length - 1) !== '/') root += '/';
    return root;
  }

  function detachDynamicCheckoutNode(foot) {
    var node = foot && foot.querySelector && foot.querySelector('#mc-dynamic-checkout');
    if (node && node.parentNode) node.parentNode.removeChild(node);
    return node || null;
  }

  function normalizeDynamicCheckoutNode(node) {
    if (!node) return null;
    node.id = 'mc-dynamic-checkout';
    if (node.className.indexOf('mc-dynamic-checkout') === -1) {
      node.className += (node.className ? ' ' : '') + 'mc-dynamic-checkout';
    }
    try { node.removeAttribute('hidden'); } catch (_) {}
    try { node.style.display = ''; } catch (_) {}
    return node;
  }

  function hydrateDynamicCheckoutNode() {
    /* v275: Cart-Buttons kommen per Section Rendering API nachtraeglich in den
       Mini-Cart. Alte Shopify-Runtimes nutzen Shopify.PaymentButton.init(),
       neue Accelerated-Checkout-Custom-Elements hydrieren selbst, sobald sie im
       DOM sind. Der Init-Call ist bewusst optional und mehrfach harmless. */
    try {
      if (w.Shopify && w.Shopify.PaymentButton && typeof w.Shopify.PaymentButton.init === 'function') {
        w.Shopify.PaymentButton.init();
      }
    } catch (_) {}
  }

  function appendDynamicCheckoutNode(slot, node) {
    if (!slot || !node) return false;
    slot.hidden = false;
    slot.innerHTML = '';
    slot.appendChild(normalizeDynamicCheckoutNode(node));
    hydrateDynamicCheckoutNode();
    w.setTimeout(hydrateDynamicCheckoutNode, 250);
    w.setTimeout(hydrateDynamicCheckoutNode, 1000);
    return true;
  }

  function mountDynamicCheckout(foot, preservedNode) {
    var slot = foot && foot.querySelector && foot.querySelector('#mc-dynamic-slot');
    if (!slot) return;

    /* v273: Logr3-Tracking für Dynamic-/Express-Checkout-Klicks (Shop Pay / PayPal / Apple-/Google-Pay).
       Spiegelt die theme.liquid-v268-Delegation (checkout_drawer_click), aber HIER im JS, weil
       theme.liquid bewusst unangetastet bleibt (v272-cls-Konflikt). Provider liegen teils in
       Shadow-DOM/Iframes + sind nicht einzeln unterscheidbar → EIN Funnel-Event
       'checkout_dynamic_click'. Dedup (800ms) gegen Doppel-Feuern; Iframe-Provider (PayPal)
       per window-blur + activeElement=IFRAME als Best-Effort, da Klicks im Cross-Origin-Iframe
       nicht zur Slot-Ebene durchschlagen. */
    var fireDynamic = function () {
      var t = Date.now();
      if (t - (w.__isoDynamicLast || 0) < 800) return;
      w.__isoDynamicLast = t;
      if (typeof w.isoCheckoutIntent === 'function') w.isoCheckoutIntent('cart_drawer_express', 'checkout_dynamic_click');
      else if (typeof w.logr3Track === 'function') w.logr3Track('checkout_dynamic_click', { step: true });
      else if (typeof w.isoTrack === 'function') w.isoTrack('checkout_dynamic_click');
    };
    if (!slot.__isoDynamicTracked) {
      slot.__isoDynamicTracked = true;
      slot.addEventListener('click', fireDynamic, true);
    }
    if (!w.__isoDynamicBlurWired) {
      w.__isoDynamicBlurWired = true;
      w.addEventListener('blur', function () {
        var ae = document.activeElement;
        if (ae && ae.tagName === 'IFRAME') {
          var s = document.getElementById('mc-dynamic-slot');
          if (s && s.contains(ae)) fireDynamic();
        }
      }, true);
    }

    var node = preservedNode || document.getElementById('CartDrawer-DynamicCheckout');
    if (node) {
      appendDynamicCheckoutNode(slot, node);
      return;
    }

    if (isLocalDev() || !w.fetch) {
      slot.hidden = true;
      return;
    }

    fetch(getRootUrl() + '?sections=cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r && r.ok ? r.json() : null; })
      .then(function (sections) {
        if (!sections || !sections['cart-drawer']) throw new Error('no cart-drawer section');
        var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
        var fresh = doc.getElementById('CartDrawer-DynamicCheckout');
        if (!fresh || !fresh.children.length) throw new Error('no dynamic checkout buttons');
        appendDynamicCheckoutNode(slot, fresh);
      })
      .catch(function () {
        slot.hidden = true;
      });
  }

  function renderCart(cart) {
    var body = document.getElementById('mc-body');
    var foot = document.getElementById('mc-foot');
    var sub  = document.getElementById('mc-head-sub');
    if (!body || !foot) return;

    var isDev = !!(cart && cart._demo);
    var items = (cart && cart.items) || [];
    var totalQty = items.reduce(function (s, it) { return s + (it.quantity || 0); }, 0);

    /* Header-Subline: "3 Artikel · 24 Flaschen" oder "Leer" */
    if (sub) {
      if (!items.length) {
        sub.textContent = 'Keine Artikel';
      } else {
        var artLbl = items.length === 1 ? '1 Artikel' : items.length + ' Artikel';
        var flLbl  = totalQty === 1 ? '1 Flasche' : totalQty + ' Flaschen';
        sub.textContent = artLbl + ' \u00b7 ' + flLbl;
      }
    }

    /* Empty-State */
    if (!items.length) {
      body.innerHTML =
        '<div class="mc-empty">' +
          '<div class="mc-empty-icon">' + ICO.cart + '</div>' +
          '<div class="mc-empty-title">Ihr Warenkorb ist leer</div>' +
          '<p class="mc-empty-text">Sobald Ihre Analyse abgeschlossen ist, wird das Sanierungspaket automatisch hier angezeigt.</p>' +
          '<a class="mc-empty-cta" href="/pages/kalkulator" data-iso-track="calc_start_cart_empty" data-iso-source="cart_empty">Sanierung starten \u2192</a>' +
          (isDev ? '<div class="mc-dev-hint" style="margin-top:16px">Dev-Modus: keine Analyse geladen</div>' : '') +
        '</div>';
      foot.innerHTML = '';
      return;
    }

    /* Personalisierter Banner über dem Item (wenn Wand-Daten vorhanden) */
    var blurb = getWallBlurb();
    var bannerH = blurb
      ? '<div class="mc-hero-banner" role="note">' +
          '<div class="mc-hero-icon">' + ICO.verified + '</div>' +
          '<div class="mc-hero-text">' +
            '<div class="mc-hero-eyebrow">Exakt berechnet f\u00fcr Ihre Wand</div>' +
            '<div class="mc-hero-detail">' + blurb + '</div>' +
          '</div>' +
        '</div>'
      : '';

    /* Produkt-Stichpunkte (USPs) — eingebettet in jede Item-Card */
    /* "Exakt berechnet f\u00fcr Ihre Wand" steht bereits im Hero-Banner oben \u2192 hier raus. */
    var uspList = [
      'Einmalige Anwendung \u2013 kein Nachbehandeln',
      'Geeignet f\u00fcr Wohn- &amp; Schlafr\u00e4ume, Keller \u2013 innen oder au\u00dfen',
      'Flascheninhalt: 500\u202fml \u2013 inkl. Injektionsaufsatz'
    ];
    var uspInner = '<ul class="mc-usp">' +
      uspList.map(function (t) {
        return '<li class="mc-usp-row"><span class="mc-usp-ico">' + ICO.check + '</span><span class="mc-usp-txt">' + t + '</span></li>';
      }).join('') +
    '</ul>';
    /* v277: USP-Liste EINMAL unter beide Items (statt pro Item) — schlankere Item-Cards. */
    var uspBoxH = '<div class="mc-usp-box"><div class="mc-usp-ttl">Gilt für Ihre Bestellung</div>' + uspInner + '</div>';

    /* Items (jedes Item enthält Ware + USPs in einer gemeinsamen Umrandung) */
    var itemsH = '';
    /* v277: Sterne (Brand-Rating) an jedes Item. */
    var _stats = (w.ISO_STATS && typeof w.ISO_STATS === 'object') ? w.ISO_STATS : {};
    var _avg = _stats.avg || '4,77';
    var _tot = (_stats.total != null) ? _stats.total : 432;
    var _starsH = '<div class="mc-item-rating"><span class="mc-item-stars" aria-hidden="true">★★★★★</span><span class="mc-item-rtxt"><strong>' + _avg + '</strong> · ' + _tot + '</span></div>';
    items.forEach(function (item, idx) {
      var line     = idx + 1;
      var thumb    = item.image || item.featured_image || '';
      var name     = item.product_title || item.title || 'Artikel';
      var disc     = getItemDiscount(item);
      var qty      = disc.qty;
      var linePrc  = disc.finalPrc;
      var priceBlock = '<div class="mc-price">' + formatEuro(linePrc) + '</div>';
      var isMainProduct = String(item.variant_id || '') === ISOFIN_VARIANT;
      /* v283: Stepper (+/-) fuer Stueck-Produkte (Messgeraet/Handbuch/Einzelflaschen); Sanierungspaket bleibt statisch */
      var _vid = String(item.variant_id || '');
      var _isEinzel = (_vid === '55868037857653');
      var _isStepper = (_vid === '55611265712501' || _vid === '56015142388085' || _isEinzel);
      var _qtyHtml, _calcHint = '';
      if (_isStepper) {
        _qtyHtml = '<div class="mc-stepper"><button type="button" class="mc-step" data-mc-dec="' + line + '" aria-label="Menge verringern">&minus;</button><span class="mc-step-val">' + qty + '</span><button type="button" class="mc-step" data-mc-inc="' + line + '" aria-label="Menge erhoehen">+</button></div>';
        if (_isEinzel) { _calcHint = '<div class="mc-calc-hint">Zur Berechnung der richtigen Flaschenanzahl empfehlen wir die Nutzung unseres <a href="/pages/kalkulator">Isofin-Kalkulators</a>.</div>'; }
      } else {
        _qtyHtml = '<span class="mc-qty-text">' + qty + '&times;&nbsp;Flaschen</span>';
      }
      var removeBtn = '<button class="mc-item-x" data-mc-remove="' + line + '" type="button" aria-label="Produkt aus Warenkorb entfernen" title="Produkt entfernen"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><line x1="6" y1="12" x2="18" y2="12"/></svg></button>';
      var recalcBtn = isMainProduct
        ? '<button class="mc-item-recalc" data-mc-recalc type="button">' + ICO.refresh + '<span>Sanierungspaket neu berechnen</span></button>'
        : '';

      /* v236.2: Properties anzeigen (z.B. "Berechnung: 8 Meter Horizontalsperre \u00b7 2 Ecken \u00b7 36 cm Wandst\u00e4rke")
         Iteriert \u00fcber item.properties (Shopify cart.js Format). Underscore-Prefix-Keys werden ignoriert. */
      var propsH = '';
      try {
        var props = item.properties;
        var pairs = [];
        if (props && typeof props === 'object') {
          if (Array.isArray(props)) {
            for (var pi = 0; pi < props.length; pi++) {
              var pair = props[pi];
              if (Array.isArray(pair) && pair.length === 2) pairs.push([pair[0], pair[1]]);
            }
          } else {
            for (var pk in props) {
              if (Object.prototype.hasOwnProperty.call(props, pk)) pairs.push([pk, props[pk]]);
            }
          }
        }
        var rowsH = '';
        for (var ri = 0; ri < pairs.length; ri++) {
          var pKey = String(pairs[ri][0] || '');
          var pVal = pairs[ri][1];
          if (!pKey || pKey.charAt(0) === '_') continue;
          if (pVal == null || pVal === '') continue;
          rowsH += '<div class="mc-prop-row">' +
                     '<span class="mc-prop-key">' + esc(pKey) + ':</span> ' +
                     '<span class="mc-prop-val">' + esc(String(pVal)) + '</span>' +
                   '</div>';
        }
        if (rowsH) propsH = '<div class="mc-props">' + rowsH + '</div>';
      } catch (_e) {}

      itemsH += '<div class="mc-item" data-mc-line="' + line + '">' +
        removeBtn +
        '<div class="mc-item-main">' +
          (thumb
            ? '<img src="' + thumb + '" alt="" class="mc-thumb" loading="lazy">'
            : '<div class="mc-thumb"></div>') +
          '<div class="mc-info">' +
            '<h4 class="mc-name">' + name + '</h4>' +
            _starsH +
            propsH +
            '<div class="mc-qtyprice">' + _qtyHtml + priceBlock + '</div>' + _calcHint +
          '</div>' +
        '</div>' +
        recalcBtn +
      '</div>';
    });

    body.innerHTML = bannerH + itemsH + (items.length ? uspBoxH : '');

    /* Footer \u2014 mit Mengenrabatt-Aufschl\u00fcsselung */
    var totals = getCartTotals(cart);
    var totalRow = totals.hasDiscount
      ? '<div class="mc-total-detail">' +
          '<div class="mc-total-row mc-total-row-orig">' +
            '<span>Listenpreis</span>' +
            '<span class="mc-total-orig-val">' + formatEuro(totals.original) + '</span>' +
          '</div>' +
          '<div class="mc-total-row mc-total-row-saved">' +
            '<span>Mengenrabatt</span>' +
            '<span class="mc-total-saved-val">\u2212' + formatEuro(totals.saved) + '</span>' +
          '</div>' +
        '</div>'
      : '';
    /* Trust-Element: Bewertung \u00fcber dem Checkout-Button (Conversion-Vertrauen direkt vor dem Klick).
       v232.3 (2026-05-24): "600+ Baustellen erfolgreich saniert"-Sub-Zeile auf User-Wunsch entfernt. */
    var stats = (w.ISO_STATS && typeof w.ISO_STATS === 'object') ? w.ISO_STATS : {};
    var avgStr = stats.avg || '4,77';
    var totalStr = (stats.total != null) ? stats.total : 432;
    var trustH =
      '<div class="mc-trust">' +
        '<div class="mc-trust-rating">' +
          '<span class="mc-trust-stars" aria-hidden="true">\u2605\u2605\u2605\u2605\u2605</span>' +
          '<span class="mc-trust-text"><strong>' + avgStr + '</strong> / 5 \u00b7 ' + totalStr + ' Bewertungen</span>' +
        '</div>' +
      '</div>';
    /* v525.8: Versandkosten-Pitch \u2014 ab 99,00 \u20ac versandkostenfrei (Copy-Gleichstand). */
    var FREE_SHIPPING_CENTS = 9900; /* 99,00 \u20ac */
    var freeShipping = (totals.final || 0) >= FREE_SHIPPING_CENTS;
    var taxNoteH = freeShipping
      ? '<small class="mc-tax-note mc-tax-note--free">inkl. MwSt. \u00b7 <strong>kostenloser Versand</strong></small>'
      : '<small class="mc-tax-note">inkl. MwSt., zzgl. Versand</small>';

    var dynamicCheckoutNode = detachDynamicCheckoutNode(foot);
    var shipH = mcShipETA();
    foot.innerHTML =
      totalRow +
      '<div class="mc-total">' +
        '<div class="mc-total-lbl">' +
          '<span>Gesamtpreis</span>' +
          taxNoteH +
        '</div>' +
        '<div class="mc-total-val">' + formatEuro(totals.final) + '</div>' +
      '</div>' +
      (shipH ? '<div class="mc-ship">' + shipH + '</div>' : '') +
      '<button class="mc-checkout" data-mc-checkout>Zur Kasse gehen <span class="isf-arrow-circle" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg></span></button>' +
      '<div class="mc-dynamic-slot" id="mc-dynamic-slot" hidden></div>' +
      (isDev ? '<div class="mc-dev-hint">Dev-Modus: lokaler Mock \u2014 Shopify-Cart ist nicht erreichbar</div>' : '');
    mountDynamicCheckout(foot, dynamicCheckoutNode);

    var coBtn = foot.querySelector('[data-mc-checkout]');
    if (coBtn) {
      coBtn.addEventListener('click', function () {
        if (isDev) {
          alert('Dev-Modus: Checkout w\u00fcrde jetzt zu /checkout navigieren.');
          return;
        }
        window.location.href = '/checkout';
      });
    }
  }

  function changeQty(lineIdx, newQty) {
    lineIdx = parseInt(lineIdx, 10); newQty = parseInt(newQty, 10);
    if (!lineIdx || lineIdx < 1 || _busy) return;
    if (!newQty || newQty < 1) { removeLine(lineIdx); return; }
    _busy = true;
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin', body: JSON.stringify({ line: lineIdx, quantity: newQty }) })
      .then(function (r) { return r && r.ok ? r.json() : null; })
      .then(function () { _busy = false; refresh(); })
      .catch(function () { _busy = false; });
  }

  function removeLine(lineIdx) {
    lineIdx = parseInt(lineIdx, 10);
    if (!lineIdx || lineIdx < 1 || _busy) return;
    _busy = true;

    var card = _panel && _panel.querySelector('[data-mc-line="' + lineIdx + '"]');
    if (card) card.classList.add('mc-item-leaving');

    /* v236.4: Sanierungspaket-Detection + SOFORT-Reset (vor postRemove).
       Storage-Clear ist von der async Cart-Mutation unabhängig — wenn User
       direkt nach Klick weiternavigiert, ist der Reset trotzdem schon passiert. */
    var wasSanierungspaket = false;
    try {
      var existingItems = (_cartData && _cartData.items) || [];
      var idx0 = lineIdx - 1;
      if (existingItems[idx0]) {
        wasSanierungspaket = String(existingItems[idx0].variant_id || '') === ISOFIN_VARIANT;
      }
    } catch (_e) {}
    if (wasSanierungspaket && w.IsoWizardReset && typeof w.IsoWizardReset.clearState === 'function') {
      try { w.IsoWizardReset.clearState(); } catch (_eR) {}
    }

    postRemove(lineIdx).then(function (cart) {
      if (cart && cart.items) {
        _cartData = cart;
        renderCart(cart);
      } else {
        return refresh();
      }
      refreshCartIconBubble();
      refreshTopbar();
      dispatchAddEvents(_cartData);
      return cart;
    }, function () {
      return refresh();
    }).then(function () {
      _busy = false;
    }, function () {
      _busy = false;
    });
  }

  function clearCalculationState() {
    try {
      if (w.IsoDash && w.IsoDash.Calculations && typeof w.IsoDash.Calculations.clearAnalysis === 'function') {
        w.IsoDash.Calculations.clearAnalysis();
      }
    } catch (_) {}
    var keys = ['isodash_project_v8','isofinHeroState','isofinAnalysis','__ISOWIZ_RESUME_ANALYSIS__','__ISOWIZ_analysis','fa_state_v2','isodash_moisture_check_completed','isodash_flow_phase','isodash_entry_mode','isodash_capillary_fit','isodash_capillary_confidence','isodash_capillary_check','isodash_masonry_type','isodash_moisture_type','isodash_analysis_source','isodash_nav_unlock_shown','isodash_a2c_done','isodash_transition_shown','__ISOWIZ_state__','__ISOWIZ_share_state__','isodash-wiz:analysis','isodash-wiz:calcState','isofinCalcState'];
    keys.forEach(function (k) {
      try { localStorage.removeItem(k); } catch (_) {}
      try { sessionStorage.removeItem(k); } catch (_) {}
    });
    try {
      for (var i = localStorage.length - 1; i >= 0; i--) {
        var lk = localStorage.key(i);
        if (lk && lk.indexOf('__ISOWIZ') === 0) localStorage.removeItem(lk);
      }
    } catch (_) {}
    try {
      for (var j = sessionStorage.length - 1; j >= 0; j--) {
        var sk = sessionStorage.key(j);
        if (sk && sk.indexOf('__ISOWIZ') === 0) sessionStorage.removeItem(sk);
      }
    } catch (_) {}
    try { if (w.IsoWiz && w.IsoWiz.Storage && typeof w.IsoWiz.Storage.resetAll === 'function') w.IsoWiz.Storage.resetAll(); } catch (_) {}
  }

  function removeSanierungspaketLines() {
    if (_cartData && _cartData._demo) {
      var kept = (_cartData.items || []).filter(function (it) {
        return String(it.variant_id || '') !== ISOFIN_VARIANT;
      });
      var total = kept.reduce(function (s, it) { return s + (it.final_line_price || it.line_price || 0); }, 0);
      var cnt = kept.reduce(function (s, it) { return s + (it.quantity || 0); }, 0);
      _cartData = { items: kept, total_price: total, item_count: cnt, _demo: true };
      return Promise.resolve(_cartData);
    }

    return fetchCart().then(function (cart) {
      var items = (cart && cart.items) || [];
      var lines = [];
      items.forEach(function (it, idx) {
        if (String(it.variant_id || '') === ISOFIN_VARIANT) lines.push(idx + 1);
      });
      if (!lines.length) return cart;

      lines.sort(function (a, b) { return b - a; });
      var chain = Promise.resolve(cart);
      lines.forEach(function (line) {
        chain = chain.then(function () { return postRemove(line); });
      });
      return chain.then(function (nextCart) {
        if (nextCart && nextCart.items) return nextCart;
        return fetchCart();
      });
    });
  }

  function refreshTopbar() {
    /* Force-refresh des Cart-Caches in der Shell — sonst greift dort der
       1.5s-Debounce und die Topbar zeigt kurz veraltete Werte. Direkt nach
       Mini-Cart-Mutationen (remove, add, …) wollen wir sofortige Konsistenz
       zwischen Cart-Sidebar und Topbar-Anzeige. */
    if (w.IsoDash && typeof w.IsoDash.refreshCartCache === 'function') {
      try { w.IsoDash.refreshCartCache(); } catch (_) {}
    } else if (w.IsoDash && typeof w.IsoDash.renderTopbarData === 'function') {
      try { w.IsoDash.renderTopbarData(); } catch (_) {}
    }
  }

  function handleReset() {
    /* Cart schließen und den zentralen Reset-Flow (Confirm-Modal + Storage-Reset + Reload)
       aus der Shell auslösen. */
    close();
    if (w.ID && typeof w.ID.resetAll === 'function') {
      /* Im Dashboard / auf Wizard-Seiten — Shell hat schon Modal + komplette Logik */
      setTimeout(function () { try { w.ID.resetAll(); } catch (_) {} }, 280);
      return;
    }
    /* v201: Standalone-Reset für alle anderen Seiten (Startseite, Produktseite, etc.) —
       Shell ist dort nicht geladen, daher inline:
       1. Confirm-Dialog, 2. Calculation-Storage löschen, 3. nur Sanierungspaket entfernen,
       4. Navigation zur Kalkulator-Seite. Separate Einzelflaschen bleiben im Warenkorb. */
    setTimeout(function () {
      if (!confirm('Möchten Sie das Sanierungspaket neu berechnen?\n\nDie aktuelle Berechnung wird zurückgesetzt. Einzelflaschen bleiben im Warenkorb.')) return;
      clearCalculationState();
      var done = false;
      function _go() {
        if (done) return;
        done = true;
        try { window.location.href = '/pages/kalkulator'; } catch (_) { window.location.reload(); }
      }
      try {
        removeSanierungspaketLines().then(_go, _go);
        setTimeout(_go, 1500);
      } catch (_) { _go(); }
    }, 280);
  }

  function refresh() {
    return fetchCart().then(function (cart) {
      _cartData = cart;
      renderCart(cart);
      refreshTopbar();
      return cart;
    });
  }

  function refreshCartIconBubble() {
    var root = '/';
    try {
      if (w.Shopify && w.Shopify.routes && w.Shopify.routes.root) root = w.Shopify.routes.root;
    } catch (_) {}
    if (!root) root = '/';
    if (root.charAt(root.length - 1) !== '/') root += '/';

    return fetch(root + '?sections=cart-icon-bubble', { credentials: 'same-origin' })
      .then(function (r) { return r && r.ok ? r.json() : null; })
      .then(function (sections) {
        if (!sections || !sections['cart-icon-bubble']) return;
        var doc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
        var next = doc.getElementById('cart-icon-bubble');
        var curr = document.getElementById('cart-icon-bubble');
        if (next && curr) curr.innerHTML = next.innerHTML;
      })
      .catch(function () {});
  }

  function dispatchAddEvents(cart) {
    try {
      document.dispatchEvent(new CustomEvent('product:added', { detail: { cart: cart || _cartData || null } }));
    } catch (_) {}
    try {
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: cart || _cartData || null } }));
    } catch (_) {}
    try {
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart || _cartData || null } }));
    } catch (_) {}
  }

  function openAfterAdd() {
    refreshCartIconBubble();
    open();
    dispatchAddEvents(_cartData);
  }

  function markUserAddIntent() {
    try { w.__IsoDashA2CUserIntentUntil = Date.now() + 6000; } catch (_) {}
  }

  function hasUserAddIntent() {
    try { return Number(w.__IsoDashA2CUserIntentUntil || 0) > Date.now(); } catch (_) {}
    return false;
  }

  function consumeUserAddIntent() {
    var ok = hasUserAddIntent();
    if (ok) {
      try { w.__IsoDashA2CUserIntentUntil = 0; } catch (_) {}
    }
    return ok;
  }

  function isCartAddUrl(raw) {
    if (!raw) return false;
    try {
      var u = new URL(raw, w.location.origin);
      return u.origin === w.location.origin && /\/cart\/add(?:\.js)?\/?$/.test(u.pathname);
    } catch (_) {
      return /\/cart\/add(?:\.js)?(?:[?#]|$)/.test(String(raw));
    }
  }

  function toAjaxCartAddUrl(raw) {
    try {
      var u = new URL(raw || '/cart/add', w.location.origin);
      return u.pathname.replace(/\/cart\/add(?:\.js)?\/?$/, '/cart/add.js');
    } catch (_) {
      return '/cart/add.js';
    }
  }

  function getQtyNear(el) {
    var root = (el && el.closest && el.closest('form,.iso-product-hero-info,.product-form')) || document;
    var input = null;
    try { input = root.querySelector('[name="quantity"],#iso-qty-input,[data-iso-quantity]'); } catch (_) {}
    var qty = parseInt(input && input.value, 10);
    if (isNaN(qty) || qty < 1) qty = 1;
    if (qty > 999) qty = 999;
    return qty;
  }

  function setLoading(el, on) {
    if (!el) return;
    if (on) {
      if (el.__isoA2cLoading) return;
      el.__isoA2cLoading = true;
      el.__isoA2cHTML = el.innerHTML;
      el.setAttribute('aria-busy', 'true');
      if ('disabled' in el) el.disabled = true;
      if (el.tagName === 'BUTTON' || el.getAttribute('role') === 'button') {
        el.innerHTML = '<span>Wird hinzugefügt ...</span>';
      }
      return;
    }
    el.__isoA2cLoading = false;
    el.removeAttribute('aria-busy');
    if ('disabled' in el) el.disabled = false;
    if (el.__isoA2cHTML != null) el.innerHTML = el.__isoA2cHTML;
  }

  function parseAddError(response) {
    return response.json()
      .then(function (err) {
        return new Error((err && (err.description || err.message)) || ('HTTP ' + response.status));
      })
      .catch(function () {
        return new Error('HTTP ' + response.status);
      });
  }

  function postCartAdd(input, opts) {
    opts = opts || {};
    var init = {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    };
    if (opts.json) {
      init.headers['Content-Type'] = 'application/json';
      init.body = JSON.stringify(input);
    } else {
      init.body = input;
    }
    return fetch(opts.url || '/cart/add.js', init)
      .then(function (r) {
        if (!r || !r.ok) return parseAddError(r).then(function (err) { throw err; });
        return r.json();
      })
      .then(function (lineItem) {
        openAfterAdd();
        return lineItem;
      });
  }

  function addAndOpen(variantId, quantity, properties) {
    var payload = { id: variantId, quantity: quantity || 1 };
    if (properties) payload.properties = properties;
    return postCartAdd(payload, { json: true });
  }

  function showAddError(el, err) {
    console.error('[IsoDashMiniCart] Add-to-cart failed:', err);
    var host = el && el.closest && el.closest('product-form');
    var wrapper = host && host.querySelector('.product-form__error-message-wrapper');
    var msg = wrapper && wrapper.querySelector('.product-form__error-message');
    if (msg) {
      msg.textContent = (err && err.message) || 'Artikel konnte nicht hinzugefügt werden.';
      wrapper.hidden = false;
      setLoading(el, false);
      return;
    }
    if (el && (el.tagName === 'BUTTON' || el.getAttribute('role') === 'button')) {
      el.innerHTML = '<span>Fehler - erneut versuchen</span>';
      setTimeout(function () { setLoading(el, false); }, 1800);
      return;
    }
    setLoading(el, false);
  }

  function wireGlobalAddToCart() {
    if (w.__IsoDashA2CBridgeWired) return;
    w.__IsoDashA2CBridgeWired = true;

    document.addEventListener('click', function (e) {
      var trigger = e.target && e.target.closest && e.target.closest('[data-iso-add-to-cart],a[href]');
      if (!trigger) return;

      if (trigger.hasAttribute('data-iso-add-to-cart')) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        if (trigger.__isoA2cLoading) return;
        var variantId = parseInt(trigger.getAttribute('data-iso-add-to-cart'), 10);
        if (!variantId) return;
        markUserAddIntent();
        setLoading(trigger, true);
        addAndOpen(variantId, getQtyNear(trigger))
          .then(function () { setLoading(trigger, false); })
          .catch(function (err) { showAddError(trigger, err); });
        return;
      }

      if (trigger.tagName === 'A' && isCartAddUrl(trigger.getAttribute('href'))) {
        if (trigger.hasAttribute('data-iso-direct-checkout')) return;
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        if (trigger.__isoA2cLoading) return;
        var url = new URL(trigger.href, w.location.origin);
        var id = url.searchParams.get('id');
        var qty = parseInt(url.searchParams.get('quantity'), 10);
        if (!qty || qty < 1) qty = getQtyNear(trigger);
        if (!id) return;
        markUserAddIntent();
        setLoading(trigger, true);
        addAndOpen(id, qty)
          .then(function () { setLoading(trigger, false); })
          .catch(function (err) { showAddError(trigger, err); });
      }
    }, true);

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.getAttribute || !isCartAddUrl(form.getAttribute('action'))) return;
      var submitter = e.submitter || document.activeElement;
      if (submitter && submitter.name === 'checkout') return;
      if (submitter && submitter.closest && submitter.closest('.shopify-payment-button')) return;
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      if (submitter && submitter.__isoA2cLoading) return;
      markUserAddIntent();
      setLoading(submitter, true);
      postCartAdd(new FormData(form), { url: toAjaxCartAddUrl(form.getAttribute('action')) })
        .then(function () { setLoading(submitter, false); })
        .catch(function (err) {
          showAddError(submitter || form, err);
          if (!submitter) setLoading(submitter, false);
        });
    }, true);
  }

  /* ── Public API ───────────────────────────────────────────── */
  function open() {
    /* v148: Defensiv — falls open() aufgerufen wird bevor init() lief
       (z.B. via header.liquid Event-Delegation auf einer Page wo es
       kein Dashboard gibt), CSS hier nachholen. */
    if (!document.getElementById(CSS_ID)) injectCSS();
    if (!_panel) _panel = buildPanel();
    _panel.classList.add('mc-open');
    _open = true;
    try { document.body.style.overflow = 'hidden'; } catch (_) {}
    refresh();
  }

  function close() {
    if (_panel) _panel.classList.remove('mc-open');
    _open = false;
    try { document.body.style.overflow = ''; } catch (_) {}
  }

  /* ── Topbar-Binding (Klick auf #tb-sys-wrap und #tb-prod-img) ── */
  function wireTopbar() {
    var tries = 0;
    var tick = function () {
      var sys = document.getElementById('tb-sys-wrap');
      var img = document.getElementById('tb-prod-img');
      var wired = 0;
      [sys, img].forEach(function (el) {
        if (!el || el.dataset.mcWired) return;
        el.style.cursor = 'pointer';
        el.setAttribute('role', 'button');
        el.setAttribute('tabindex', '0');
        el.setAttribute('aria-label', 'Warenkorb \u00f6ffnen');
        el.addEventListener('click', function (e) { e.preventDefault(); open(); });
        el.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); }
        });
        el.dataset.mcWired = '1';
        wired++;
      });
      tries++;
      if (!(sys && img) && tries < 30) setTimeout(tick, 250);
    };
    tick();
  }

  function init() {
    injectCSS();
    wireTopbar();
    wireGlobalAddToCart();
  }

  w.IsoDashMiniCart = {
    open: open,
    close: close,
    refresh: refresh,
    init: init,
    openAfterAdd: openAfterAdd,
    addAndOpen: addAndOpen,
    markUserAddIntent: markUserAddIntent,
    consumeUserAddIntent: consumeUserAddIntent,
    hasUserAddIntent: hasUserAddIntent
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})(window);
